import { CustomErrorCode } from '@app/services/SettingAxios';

export class NoToken extends Error {
  extra: unknown;
  code: CustomErrorCode;

  constructor(extra?: unknown) {
    super('jwt токена нет');
    this.name = this.constructor.name;
    this.extra = extra;
    this.code = CustomErrorCode.NoToken;
    Error.captureStackTrace(this, this.constructor);
  }
}
